import { render, staticRenderFns } from "./index.vue?vue&type=template&id=151fba6e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=151fba6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fba6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('151fba6e')) {
      api.createRecord('151fba6e', component.options)
    } else {
      api.reload('151fba6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=151fba6e&scoped=true&", function () {
      api.rerender('151fba6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/allOrders/index.vue"
export default component.exports